import { Box, Modal, Typography } from "@mui/material";
import { IModalClusters } from "./ModalClustersInterfaces";
import { useStyles, modalStyles } from "./ModalClusters.styles";

export const ModalClusters = ({ open, handleClose, title, children }: IModalClusters) => {
    const classes = useStyles();
    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={modalStyles}>
                <Typography className={classes.modalTitle}>{title}</Typography>
                <Box className={classes.bodyContainer}>{children}</Box>
            </Box>
        </Modal>
    );
};
